<template>
  <b-dropdown class="d-inline-flex mx-1" size="sm" :text=name >
    <div class="scrollable">
        <b-list-group>
          <template v-if="link.value>1e-4" v-for="link,linkid in links">
            <b-list-group-item class="nowrap" disabled :key=link.id>
              <div>
                <b class="d-flex">{{link.source.name}} -> {{link.target.name}}</b>
                <div class="flex-row">
                  <span class="symbol" v-if="auth" style="cursor:pointer" @click="e=>{edit_link(link.value.toFixed(sigfig),linkid)}">&#x270E;</span>
                  <span v-if="edit_str!=(linkid.toString()+'_value')">{{link.value.toFixed(sigfig)}}</span>
                  <input v-focus @blur="done" @keyup.enter="done" v-if="edit_str==(linkid.toString()+'_value')" v-model="edit_content">
                  quads
                </div>
                <div v-if="has_reference(link) || auth" class="flex-row">
                  <span class="symbol" v-if="auth" style="cursor:pointer" @click="e=>{edit_reference(link.reference,linkid)}">&#x270E;</span>
                  <template v-if="has_reference(link)">
                    <a v-if="edit_str!=(linkid.toString()+'_reference')" class="linkref" :href=link.reference target="_blank">{{link.reference}}</a>
                  </template>
                  <template v-else>
                    <em v-if="edit_str!=(linkid.toString()+'_reference')" class="linkref">(add reference...)</em>
                  </template>
                  <input class="linkref edit" v-focus @blur="done" @keyup.enter="done" v-if="edit_str==(linkid.toString()+'_reference')" v-model="edit_content">
                </div>
              </div>
            </b-list-group-item>
          </template>
        </b-list-group>
    </div>
  </b-dropdown>
</template>

<script>

import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'

import * as d3 from 'd3'

import utils from '../utils'

const focus = {
  inserted(el) {
    el.focus()
  },
}

export default {
  name:'LinksList',
  props: ['links','name','incoming'],
  components: {},
  data () {
    return {
      edit_str:"",
      edit_store:"",
      edit_content:""
    }
  },
  directives: { focus },
  computed:{
    ...mapState({
      auth: state => state.backend.isAuthenticated,
      sigfig: state => (state.sigfig+1)
    }),
  },
  methods:{
    has_reference(l) {
      return l.reference && l.reference.length
    },
    edit_reference(t,id){
      this.edit_store = t
      this.edit_content = t
      this.edit_str = id.toString()+"_reference"
    },
    edit_link(t,id){
      this.edit_store = t
      this.edit_content = t
      this.edit_str = id.toString()+"_value"
    },
    done(){
      if(!this.edit_str.length) return
      var parts = this.edit_str.split("_")
      var id = parseInt(parts[0])
      var field = parts[1]
      var val = this.edit_content
      var compare = this.links[id][field]
      if(field.includes("value")) {
        val = parseFloat(val)
        compare = compare.toFixed(this.sigfig)
      }
      if (val!=compare){
        Vue.set(this.links[id],field,val)
        this.$store.commit("set_dirty",true)
      }
      this.edit_store=""
      this.edit_content=""
      this.edit_str=""
    },
    clickout(e){
      this.done()
    },
  }
}
</script>

<style scoped>

.dropdown >>> div {
    padding-top:0px;
    padding-bottom:0px;
}

.nowrap{
    white-space: nowrap;
    padding-left:5px;
}

.scrollable{
    height:auto;
    max-height:450px;
    overflow-y: auto;
}

.linkref{
    font-size:11px;
}

.symbol{
    font-size:12px;
}

.edit{
    width:100%;
}

</style>



// WEBPACK FOOTER //
// src/components/LinksList.vue